import { Drawer, IconButton, Tabs, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledHeaderLogo = styled("div")(({ openDrawer }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundRepeat: "no-repeat",
  overflow: "hidden",
  WebkitTransition: "background-image 0.5s ease-in-out",
  transition: "background-image 0.5s ease-in-out",
  backgroundPosition: "center",
  backgroundSize: openDrawer ? "auto 50px" : "auto 25px",
  height: "120px",
  width: "100%",
  backgroundImage: openDrawer
    ? 'url("assets/route-large.svg")'
    : 'url("assets/eco-mobility-tonal-xl-symbol.svg")'
}))

export const StyledMenuTabs = styled(Tabs)(({ theme, openDrawer }) => ({
  marginLeft: openDrawer && 12,
  marginRight: openDrawer && 12,
  height: "100%",
  "& .MuiTab": {
    flexDirection: "row",
    justifyContent: "left",
    [theme.breakpoints.up("sm")]: {
      justifyContent: !openDrawer && "center"
    }
  },
  "& .MuiTab-labelIcon": {
    minHeight: "48px",
    borderRadius: "8px",
    "& .MuiTab > *:first-of-type": {
      marginRight: "13px",
      marginBottom: 0
    },
    paddingLeft: openDrawer && "15px"
  },
  "& .MuiTab-root": {
    minWidth: "auto",
    color: theme.palette.grey[100]
  },

  "& .Mui-selected": {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: "white !important",
    opacity: 1
  },
  "& .MuiTabs-indicator": {
    width: 4,
    left: 0,
    borderRadius: "0.3rem 0 0 0.3rem"
  }
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: `${theme.palette.secondary[100]} !important`,
  paddingLeft: "15px",
  paddingTop: "20px"
}))

export const StyledToggleDrawerIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary[200],
  color: theme.palette.secondary[700],
  right: 0,
  borderRadius: "0.3rem 0 0 0.3rem",
  padding: "8px",
  marginBottom: "8px",
  "&:hover": {
    backgroundColor: theme.palette.secondary[300]
  }
}))

export const StyledDiv = styled("div")(({ openDrawer }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  overflow: "hidden",
  height: "60px",
  background: "white",

  "& img": {
    width: "auto",
    maxWidth: "100%",
    padding: openDrawer ? "0 25px" : "5px"
  }
}))

const drawerWidth = "240px"
export const StyledMenuDrawer = styled(Drawer)(({ theme, openDrawer }) => ({
  position: "relative",
  overflowX: "hidden",
  flexShrink: 0,
  width: openDrawer ? drawerWidth : "60px",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.enteringScreen
  }),
  "& .MuiListItemIcon-root": {
    minWidth: "35px"
  },
  "& .MuiTab-labelIcon": {
    flexDirection: "row",
    justifyContent: "left",
    color: "white",
    "& svg": {
      marginRight: "13px"
    }
  },
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen
    }),
    [theme.breakpoints.up("sm")]: {
      width: openDrawer ? drawerWidth : "60px"
    }
  },

  [theme.breakpoints.up("sm")]: {
    borderRight: "1px solid #212737"
  },
  [theme.breakpoints.down("xs")]: {
    width: openDrawer ? drawerWidth : 0,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  "& > .MuiPaper-root": {
    background: theme.palette.secondary[800]
  }
}))
